export function redirectToActivity(activityId, forcePreviewMode) {
  let url = `/activity_sessions/anonymous?activity_id=${activityId}`
  if (forcePreviewMode) url = `${url}&teacher_preview=true`
  window.open(url, '_blank');
};
